import { KuiTabBarComponent } from './tab-bar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KuiActionModule } from 'app/key-ui/action/action.module';
import { KuiIconModule } from 'app/key-ui/icon/icon.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
@NgModule({
    imports: [
        CommonModule,
        KuiActionModule,
        KuiIconModule,
        DragDropModule
    ],
    exports: [KuiTabBarComponent],
    declarations: [KuiTabBarComponent],
})
export class KuiTabBarModule { }
